import { Component, OnInit, inject } from '@angular/core'
import {
  Event as NavigationEvent,
  NavigationStart,
  Router,
} from '@angular/router'
import { filter } from 'rxjs'

import { FeatureFlagService } from '../../../helpers/feature-flag.service'

@Component({
  standalone: false,
  templateUrl: './overview.component.html',
  styleUrls: ['overview.component.scss'],
})
export class OverviewComponent implements OnInit {
  router = inject(Router)
  featureFladService = inject(FeatureFlagService)

  public tabs = [
    { title: 'dashboard', selected: false },
    { title: 'hunts', selected: false },
    { title: 'hunt templates', selected: false },
  ]

  public onTabSelect(e): void {
    const path = e.title.replace(' ', '-')
    this.router.navigate(['hunt', path])
  }

  constructor() {
    const router = this.router

    router.events
      .pipe(
        filter((event: NavigationEvent) => {
          return event instanceof NavigationStart
        }),
      )
      .subscribe((event: NavigationStart) => {
        this.updateSelectedTab(event.url)
      })
  }

  public ngOnInit(): void {
    this.updateSelectedTab(this.router.url)
  }

  /**
   * Determines which tab should currently be selected based on the current route,
   * necessary for direct navigation by url and also when the back button is pressed
   * @param route
   */
  public updateSelectedTab(route: string): void {
    route = route.split('/').pop()
    if (route.includes('?')) {
      route = route.substring(0, route.indexOf('?'))
    }
    route = route.replace('-', ' ')

    this.tabs.forEach((tab) => {
      if (tab.title == route) tab.selected = true
      else tab.selected = false
    })
  }
}
